export default "__VITE_ASSET__BIa1TLkk__"